



import * as MainActionCreator from './Main';
import * as StatRusActionCreator from './StatRus';
import * as MonoActionCreator from './Mono';




// обьеднуємо усі екшени
export default {
  ...MainActionCreator,
  ...StatRusActionCreator,
  ...MonoActionCreator
  
}